/**
 *  BLOCK: Wubook
 *  ---
 *  Add Wubook Booking Engine iFrame to a Page
 */

const { __ } = wp.i18n
const { registerBlockType } = wp.blocks;

var snakeCaseKeys = require('snakecase-keys')

import EditBlock from "./EditBlock.js"

const wubookSVG = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.03 14.62">
                  <g id="g1992-6" transform="matrix(0.23258861,0,0,0.23258861,-22.404226,-90.629539)">
                    <path id="path1988-7" d="m 115,432.9 c -0.7,12.7 4,19.1 11.1,19.6 6.9,0.5 10.9,-2.8 13.2,-13.3 
                              0.8,-3.7 4.6,-15.5 6.8,-19.8 3.1,-6.2 6.8,-10.6 10.6,-12.8 9.2,-5.2 17.3,-2.2 19.8,-0.6 
                              5.7,3.5 7.8,9.3 7.8,14.1 0,5.5 -2.8,9.2 -4.5,10.9 -4.3,4.2 -8.7,4.7 -11.3,4.7 -5.1,0 
                              -10.7,-4.1 -11.7,-9.7 -0.4,-2.4 -0.2,-6 2.2,-8.5 3.1,-3.3 10.1,-4.6 13,1 2.6,5 -3.4,7.3 
                              -5.2,3.4 -1.6,-3.5 -5.4,-0.7 -5.2,1.6 0.2,2.3 1.1,4.4 3,5.4 6,3.2 12.2,-0.1 13.6,-5.1 
                              0.9,-3.2 0.2,-7.5 -2.3,-10.6 -1.9,-2.4 -4.9,-4.8 -10.5,-4.5 -8.6,0.5 -13.2,6.9 -14.2,12.3 
                              -0.5,2.6 -0.2,5.2 0.4,7.2 -2.4,0.2 -5.1,0.6 -6.2,0.7 -0.7,0.1 -0.8,0.1 -1,0.2 -0.5,0.2 
                              -0.7,0.5 -0.7,1 v 0 c 0,0.2 0,0.2 1.5,4.4 l 1.5,4.2 0.1,0.1 c 0.2,0.2 0.4,0.3 0.7,0.3 0.1,0 
                              0.2,0 0.3,0 0.1,0 0.4,-0.2 3.5,-2.1 l 3.4,-2.2 c 0.7,1 1.4,1.9 2.3,2.7 -2,2.2 -4.2,4.9 -5,5.9 
                              -0.5,0.7 -0.6,0.8 -0.7,1 -0.3,0.5 -0.2,1 0.2,1.4 0.1,0.1 0.1,0.1 5.1,2.7 l 4.9,2.5 h 0.2 c 
                              0,0 0,0 0,0 0.4,0 0.8,-0.2 1,-0.6 0.1,-0.2 0.2,-0.5 1.3,-4.8 l 1.3,-4.8 -0.4,-0.2 c 1.3,0.2 
                              2.7,0.3 4.3,0.3 v 0.5 c -0.2,3.4 -0.4,7.4 -0.5,8.9 0,0.9 0,1.1 0,1.4 0.1,0.7 0.5,1 1.1,1.1 0,0 
                              0.1,0 0.1,0 0.2,0 1,-0.1 6.1,-1.1 l 6,-1.1 0.2,-0.1 c 0.4,-0.3 0.6,-0.7 0.5,-1.2 0,-0.2 
                              -0.2,-0.6 -2.1,-5.1 l -2,-4.9 c 1,-0.5 2,-1.1 2.9,-1.9 l 0.3,0.3 c 1.9,2.4 4.4,5.3 5.3,6.4 
                              0.6,0.7 0.7,0.8 0.9,0.9 0.3,0.2 0.5,0.3 0.8,0.3 0.2,0 0.5,-0.1 0.7,-0.2 v 0 c 0.2,-0.1 0.2,-0.1 
                              3.6,-4.6 l 3.4,-4.5 v -0.2 c 0.1,-0.4 -0.1,-0.9 -0.4,-1.2 -0.1,-0.1 -0.5,-0.3 -4.6,-2.2 l 
                              -4.5,-2.1 c 0.5,-1 0.9,-2 1.2,-3.1 l 0.4,0.1 c 2.8,0.9 6.3,1.9 7.6,2.2 0.8,0.2 0.9,0.2 1.2,0.2 
                              0,0 0.1,0 0.1,0 0.5,0 0.9,-0.2 1.1,-0.8 0.1,-0.2 0.1,-0.2 0.4,-5.5 l 0.3,-5.4 -0.1,-0.2 c 
                              -0.1,-0.4 -0.5,-0.7 -0.9,-0.7 -0.2,0 -0.5,0 -4.8,0.7 l -3.9,0.7 c 0,-1.4 -0.2,-2.7 -0.5,-4.1 
                              2.8,-0.3 6.1,-0.8 7.3,-1 0.8,-0.1 0.9,-0.2 1.1,-0.2 0.5,-0.2 0.8,-0.6 0.7,-1.1 v 0 c 0,-0.2 
                              0,-0.2 -1.8,-4.9 l -1.8,-4.7 -0.1,-0.1 c -0.3,-0.3 -0.7,-0.4 -1.1,-0.2 -0.2,0 -0.4,0.2 
                              -3.8,2.5 l -3.7,2.5 c -0.6,-0.9 -1.4,-1.8 -2.2,-2.5 l 0.1,-0.1 c 2,-1.9 4.4,-4.4 5.2,-5.3 
                              0.5,-0.6 0.6,-0.7 0.7,-0.9 0.3,-0.5 0.3,-0.9 -0.1,-1.3 -0.1,-0.1 -0.1,-0.1 -4.4,-2.8 l -4.3,-2.7 
                              h -0.2 c -0.4,0 -0.8,0.1 -1,0.5 -0.1,0.1 -0.2,0.4 -1.5,4.3 l -1.4,3.9 c -1.3,-0.5 -2.8,-0.9 
                              -4.4,-1.2 0.6,-2.7 1.4,-5.9 1.6,-7.1 0.1,-0.8 0.2,-0.9 0.2,-1.1 0,-0.6 -0.2,-0.9 -0.8,-1.1 
                              -0.2,-0.1 -0.2,-0.1 -5.2,0 h -5.1 l -0.2,0.1 c -0.3,0.2 -0.6,0.5 -0.6,0.9 0,0.2 0.1,0.5 1,4.5 
                              l 0.8,3.4 c -1.5,0.2 -2.9,0.5 -4.2,0.9 -0.7,-2.6 -1.6,-5.8 -1.9,-6.9 -0.2,-0.7 -0.3,-0.9 -0.4,-1.1 
                              -0.3,-0.5 -0.6,-0.7 -1.2,-0.6 -0.2,0 -0.2,0 -4.6,2.5 l -4.5,2.4 -0.1,0.2 c -0.2,0.3 -0.3,0.7 
                              -0.1,1.1 0.1,0.1 0.3,0.4 3,3.5 l 2.3,2.7 c -1.2,0.9 -2.3,1.8 -3.4,2.8 -1.7,-2 -3.8,-4.5 -4.6,-5.4 
                              -0.5,-0.5 -0.6,-0.6 -0.8,-0.8 -0.4,-0.3 -0.8,-0.3 -1.3,0 -0.1,0.1 -0.1,0.1 -3,4 l -2.9,3.9 v 0.2 c 
                              -0.1,0.4 0.1,0.7 0.3,1 0.1,0.1 0.4,0.2 4,1.8 l 3.1,1.4 c -1,1.5 -1.9,3 -2.7,4.4 l -0.1,-0.1 c 
                              -1.8,-1.4 -4,-3.2 -4.8,-3.8 -0.5,-0.4 -0.6,-0.4 -0.8,-0.5 -0.4,-0.2 -0.8,-0.1 -1.1,0.2 -0.1,0.1 
                              -0.1,0.1 -1.9,3.9 l -1.8,3.8 v 0.2 c 0,0.3 0.2,0.6 0.5,0.8 0.1,0.1 0.4,0.1 3.7,0.8 l 3.3,0.7 c 
                              -0.5,1.3 -1,2.5 -1.4,3.5 -1.9,-0.8 -4.2,-1.8 -5.1,-2.1 -0.6,-0.2 -0.7,-0.2 -0.8,-0.3 -0.4,-0.1 
                              -0.7,0.1 -0.9,0.4 v 0 c -0.1,0.1 -0.1,0.1 -0.7,4 l -0.6,3.9 v 0.1 c 0.1,0.3 0.3,0.5 0.6,0.6 0,0 
                              0.1,0 0.2,0 0.3,0 1,0 3.3,-0.2 l 2.1,-0.1 c -0.3,1.1 -0.6,2.3 -0.8,3.4 -1.6,-0.3 -3.6,-0.7 -4.4,-0.8 
                              -0.5,-0.1 -0.5,-0.1 -0.7,-0.1 -0.3,0 -0.5,0.2 -0.6,0.5 0,0.1 0,0.1 0.1,3.2 l 0.2,3 0.1,0.1 c 0.1,0.2 
                              0.3,0.3 0.6,0.3 v 0 c 0.1,0 0.3,-0.1 2.7,-0.7 l 0.8,-0.2 c -0.8,2.4 -2.9,5.7 -6.5,4.8 -2.3,-0.6 
                              -7.1,-3.2 -5.1,-14.6" class="st0" />
                    <path id="path1990-5" d="m 124.8,446 c -4.4,-3.9 -4.5,-5.9 -3.6,-15.5 0.5,-5.3 2.2,-9.6 4.3,-12.9 2.2,-3.3 
                              2.7,-4.3 4.5,-7.2 4.2,-6.7 3.1,-11.3 -1.5,-14.9 -1.7,-1.3 -4.2,-2.2 -5.8,-2.6 -9.3,-2.7 -16.9,-1.8 
                              -22.7,-0.4 -3.8,0.9 -3.4,2.9 -3,3.9 0.4,1 5.3,4 7.5,5.3 14.6,8.8 10.9,25.1 10.5,30.1 -0.7,9.3 1,15.5 
                              5,18.5 m -6.9,-55.2 c 0,0 -0.1,0.1 -0.3,0.1 -0.5,0.2 -1.7,0.8 -2.6,2.4 -1,1.8 -0.7,3.1 -0.6,3.5 0,0.2 
                              0.1,0.3 0,0.4 0,0 0,0 -0.1,0 -0.1,0 -0.1,0 -0.2,-0.1 -0.1,-0.1 -0.3,-0.3 -0.5,-0.5 -0.5,-0.5 -1.4,-1.4 
                              -2.9,-2.5 -0.8,-0.6 -1.3,-0.9 -1.7,-1.2 -0.3,-0.2 -0.5,-0.3 -0.6,-0.5 0,0 -0.1,-0.1 -0.1,-0.1 -0.2,-0.2 
                              -0.4,-0.3 -0.3,-0.7 0.1,-0.2 0.1,-0.3 0.2,-0.4 0,0 0.1,0 0.1,0 0.2,-0.1 0.8,-0.5 2.3,-0.9 1.8,-0.4 
                              3.7,-0.5 4.8,-0.4 h 0.1 c 1.5,0.1 2.2,0.2 2.3,0.5 0.2,0.2 0.2,0.3 0.1,0.4 z m 8.3,3 c 2.7,-0.3 5.1,1.6 
                              5.4,4.3 0.3,2.7 -1.6,5.1 -4.3,5.4 -2.7,0.3 -5.1,-1.6 -5.4,-4.3 -0.4,-2.7 1.6,-5.1 4.3,-5.4 z" class="st0" />
                  </g>
                  <path style={{strokeWidth:0.23258863}} d="m 5.3435945,3.4060348 c -0.255847,-0.6047305 0.325624,-1.1862019 
                              0.930355,-0.9303543 0.162812,0.069776 0.279106,0.1860706 0.348883,0.3488826 C 6.8786805,3.4292937 6.2972085,4.010765 
                              5.6924775,3.7549179 5.5296655,3.6851409 5.4133715,3.545588 5.3435945,3.4060348 Z" class="st0" id="path75_2_-3" />
                  </svg>


registerBlockType('bed66-blocks/wubook', {

    title: 'Wubook',
  
    icon: wubookSVG,
  
    category: 'bed66',
  
    attributes: {
      defaultURL: {
        type: 'string',
        default: 'https://static.wubook.net/shstatic/imgs/wb.svg'
      },
      tempURL: {
        type: 'string',
        default: 'https://static.wubook.net/shstatic/imgs/wb.svg'
      },
      url: {
        type: 'string',
        default: ''
      },
      widthField: {
        type: 'string',
        default: '100%',
      },
      heightField: {
        type: 'string',
        default: '500px',
      },
      borderField: {
        type: 'string',
        default: '0'
      },
      scrollField: {
        type: 'string',
        default: 'no'
      },
      classField: {
        type: 'string',
        default: 'iframe-class'
      },
      lcode: {
        type: 'string',
        default: '',
      },
      dcode: {
        type: 'string',
        default: '',
      },
      lang: {
        type: 'string',
        default: '',
      },
      sessionSeed: {
        type: 'string',
        default: '',
      },
      onlyRooms: {
        type: 'string',
        default: '',
      },
      customColors: {
        type: 'object',
        default: {
          background: '',
          addressBackground: '',
          addressText: '',
          topBar: '',
          topBarText: '',
          buttonBackground: '',
          buttonText: '',
          amenity: '',
          promoBackground: '',
          promoText: '',
          continueButtonBackground: '',
          continueButtonText: '',
          roomsText: '',
          virtualsText: '',
          pricesText: '',
          offersText: '',
          calendarEndpointBackground: '',
          calendarBetweenBackground: ''
        }
      },
      eurota: {
        type: 'string',
        default: '',
      },
      currency: {
        type: 'string',
        default: '',
      },
      bookRooms: {
        type: 'string',
        default: '',
      },
      pid: {
        type: 'string',
        default: '',
      },
      occupancies: {
        type: 'string',
        default: '',
      },
      filters: {
        type: 'string',
        default: '',
      },
      relink: {
        type: 'string',
        default: '',
      }
    },
  
    edit: EditBlock,
  
    save( { attributes } ) {
      const { url, widthField, heightField, borderField, scrollField, classField, 
              lcode, dcode, lang, sessionSeed, onlyRooms, customColors, eurota, currency, bookRooms, 
              pid, occupancies, filters, relink} = attributes;
  
      return (
        <div>
        <iframe src={url + "?ref=bed66&lcode=" + lcode + "&dcode=" + dcode + "&lang=" + lang 
                    + "&sessionSeed=" + sessionSeed + "&onlyrooms=" + onlyRooms + "&custom_colors=" + JSON.stringify(snakeCaseKeys(customColors))
                    + "&eurota=" + eurota + "&currency=" + currency + "&bookrooms=" + bookRooms + "&=pid" + pid
                    + "&occupancies=" + occupancies + "&filters=" + filters + "&relink=" + relink} 
        width={widthField} height={heightField} frameborder={borderField} scrolling={scrollField} class={classField} id="bed66_iFrame"></iframe>
        <script type="text/javascript" src="https://hotels.cloudbeds.com/widget/iFrameResizer"></script><script>window.iFrameResize({"{}"}, '#bed66_iFrame')</script>
        </div>
        );
    },

  });